export default "__VITE_PUBLIC_ASSET__aa760c7e__"